<template>
  <v-card class="border">
    <div class="d-flex justify-space-between align-center">
      <v-card-title>
        {{ $ucfirst($t("alerts.recent")) }}
      </v-card-title>
      <alerts-filter
        :alertCount="recentAlertsCount"
        v-model="filter"
      ></alerts-filter>
    </div>
    <alerts-table
      class="patient-overview-recent-alerts__table mt-4"
      :filters="filter"
      :patient-id="patientId"
      recent
      @update:alertCount="(v) => this.recentAlertsCount = v"
    ></alerts-table>
  </v-card>
</template>

<script>
import AlertsFilter from "../../../components/Alerts/AlertsFilter";
import AlertsTable from "../../../components/Alerts/AlertsTable";
import { mapGetters } from "vuex";

/**
 * Component PatientOverviewRecentAlerts.vue
 *
 * @module PatientOverviewRecentAlerts
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.1] app/src/APP_DASHBOARD/templates/views/Patient/Overview/PatientOverviewRecentAlerts.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewRecentAlerts",
  components: {
    AlertsFilter,
    AlertsTable,
  },
  data() {
    return {
      filter: ["red", "orange", "yellow", "active"],
      recentAlertsCount: {
        red: 0,
        orange: 0,
        yellow: 0,
        handled: 0,
        active: 0
      },
    };
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
    }),
  },
};
</script>

<style lang="scss">
.patient-overview-recent-alerts__empty {
  font-weight: 600;
}
</style>
